import { render, staticRenderFns } from "./SellMultipleProducts.vue?vue&type=template&id=13ccbaef&scoped=true"
import script from "./SellMultipleProducts.vue?vue&type=script&lang=js"
export * from "./SellMultipleProducts.vue?vue&type=script&lang=js"
import style0 from "./SellMultipleProducts.vue?vue&type=style&index=0&id=13ccbaef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ccbaef",
  null
  
)

export default component.exports